import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 2rem;
  min-height: 60vh;
`;

const Title = styled.h1`
  color: #ffffff;
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: 700;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
`;

const TableHeader = styled.thead`
  background: rgba(204, 0, 0, 0.2);
`;

const TableRow = styled.tr`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

const TableHeaderCell = styled.th`
  padding: 1rem;
  text-align: left;
  color: #ffffff;
  font-weight: 600;
`;

const TableCell = styled.td`
  padding: 0.75rem 1rem;
  color: #cccccc;
  
  &:nth-child(3) {
    color: #cc0000;
    font-weight: 700;
  }
  
  &:nth-child(4) {
    color: #00aa00;
    font-weight: 700;
  }
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  
  &::after {
    content: '';
    width: 40px;
    height: 40px;
    border: 4px solid #444;
    border-top: 4px solid #cc0000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

function DebugScoresPage() {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadScores();
  }, []);

  const loadScores = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/debug/scores');
      const data = await response.json();
      setSongs(data);
    } catch (error) {
      console.error('Error loading scores:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  if (loading) {
    return (
      <PageContainer>
        <LoadingSpinner />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Title>Debug: Song Scores</Title>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>ID</TableHeaderCell>
            <TableHeaderCell>Song Name</TableHeaderCell>
            <TableHeaderCell>Current Amount</TableHeaderCell>
            <TableHeaderCell>Score</TableHeaderCell>
            <TableHeaderCell>Last Confirmed</TableHeaderCell>
            <TableHeaderCell>Last Adjustment Date</TableHeaderCell>
            <TableHeaderCell>Need Confirm</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <tbody>
          {songs.map((song) => (
            <TableRow key={song.id}>
              <TableCell>{song.id}</TableCell>
              <TableCell>{song.name}</TableCell>
              <TableCell>{song.current_amount}</TableCell>
              <TableCell>{song.adjustment_score || 0}</TableCell>
              <TableCell>{formatDate(song.last_confirmed_at)}</TableCell>
              <TableCell>{formatDate(song.last_adjustment_date)}</TableCell>
              <TableCell>{song.need_count_confirm ? 'Yes' : 'No'}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </PageContainer>
  );
}

export default DebugScoresPage;


















